export default function Check({ className }: { className?: string }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='40' height='41' viewBox='0 0 40 41' fill='none' className={className}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 35.8301V35.8301C11.715 35.8301 5 29.1151 5 20.8301V20.8301C5 12.5451 11.715 5.83008 20 5.83008V5.83008C28.285 5.83008 35 12.5451 35 20.8301V20.8301C35 29.1151 28.285 35.8301 20 35.8301Z'
        stroke='white'
        strokeWidth='1.74563'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.6673 17.4971L18.334 25.8304L13.334 20.8304'
        stroke='white'
        strokeWidth='1.74563'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
